export const getMyGroups = (state) => state.myGroups;

// myDirections: directionJSON,
// 	myDirectionsIds: idsDirection,
// 	myDirectionsSelect: selectDirection,
